import * as mutations from 'graphql/mutations'
import * as queries from 'graphql/queries'

export const epoin = {
  ...mutations,
  ...queries,
}
